
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#FFF","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M16.364 4.91a2.73 2.73 0 00-2.728 2.726 2.73 2.73 0 002.728 2.728 2.73 2.73 0 002.727-2.728 2.73 2.73 0 00-2.727-2.727zm0 4.363a1.638 1.638 0 01-1.637-1.637c0-.902.734-1.636 1.637-1.636C17.266 6 18 6.734 18 7.636c0 .903-.734 1.637-1.636 1.637z"}}),_c('path',{attrs:{"d":"M23.455 1.636c0-.29-.114-.565-.32-.77a1.082 1.082 0 00-.772-.32c-4.43.007-7.643.327-11.84 4.522-1 1-1.91 2.136-2.712 3.384a4.364 4.364 0 00-1.691-.341c-1.51 0-2.889.76-3.69 2.033L.72 12.871c-.215.341-.252.646-.111.903.176.32.548.435 1.046.271a7.64 7.64 0 012.355-.38c.434 0 .866.041 1.287.119-.15.474-.247.834-.296 1.036-.09.355.035.804.299 1.068l2.809 2.81c.26.26.72.39 1.068.301.202-.05.563-.146 1.038-.296.293 1.568-.026 2.929-.26 3.641-.044.132-.176.532.057.856a.663.663 0 00.546.273c.177 0 .364-.063.57-.193l2.728-1.712a4.344 4.344 0 001.692-5.38c1.249-.8 2.387-1.713 3.384-2.71 4.193-4.195 4.513-7.411 4.523-11.842zm-8.898 13.887l-.452.273.262.46a3.26 3.26 0 01-1.09 4.387l-2.08 1.3c.232-1.006.387-2.48-.059-4.096l-.156-.564-.55.193c-.722.252-1.262.399-1.55.45l-2.824-2.84c.065-.26.21-.804.462-1.52l.195-.55-.563-.156c-1.393-.385-2.995-.317-4.103-.06l1.306-2.08a3.244 3.244 0 012.764-1.523c.567 0 1.128.15 1.621.431l.46.263.276-.451a19.428 19.428 0 012.817-3.604c3.909-3.908 6.791-4.195 11.068-4.204-.008 4.28-.295 7.163-4.204 11.068a19.125 19.125 0 01-3.6 2.823z"}}),_c('path',{attrs:{"d":"M.705 22.523l4.364-4.364.771.772-4.363 4.363zM.705 19.25l3.273-3.273.772.772-3.273 3.273zM4.75 23.295l-.771-.771 3.273-3.273.77.771z"}})])])
          )
        }
      }
    